module.exports = __webpack_public_path__ + "static/media/Hermione Granger 1.81105d4b.jpg";